(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sibling-product-swatches"] && !Shopify.designMode) return;
  try {
    // Sync size radio selection in sibling-product-swatches with the product form's hidden variant ID input
  document.addEventListener('change', (event) => {
    const radio = event.target;
    if (!radio.matches || !radio.matches('.sibling-product-swatches-block input[type="radio"][data-variant-id]')) return;

    const variantId = radio.dataset.variantId;
    if (!variantId) return;

    // Update the hidden variant ID input in the product form
    const productForm = document.querySelector('product-form-component');
    const hiddenInput = productForm?.querySelector('input[name="id"]');
    if (hiddenInput) {
      hiddenInput.value = variantId;
    }

    // Update the URL so the variant is reflected in the address bar
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variantId);
    history.replaceState({}, '', url.toString());

    // Re-enable the add to cart button (variant-picker normally does this via VariantUpdateEvent)
    const addToCartBtn = productForm?.querySelector('[ref="addToCartButton"]');
    if (addToCartBtn) {
      addToCartBtn.disabled = false;
    }
  });
  } catch(e) { console.error(e); }
})();

})();
